const pad2 = value => String(value).padStart(2, '0');

export function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function addDays(date, amount) {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
}

export function nextMonday(from = new Date()) {
  const date = new Date(from);
  const day = date.getDay();
  const delta = day === 1 ? 7 : (8 - day) % 7 || 7;
  date.setDate(date.getDate() + delta);
  date.setHours(9, 0, 0, 0);
  return date;
}

export function atHour(date, hour = 9) {
  const next = new Date(date);
  next.setHours(hour, 0, 0, 0);
  return next;
}

export function formatHourLabel(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  if (minutes === 0) return `${hours}h`;
  return `${hours}h${pad2(minutes)}`;
}

export function formatAppointmentChip(iso, now = new Date()) {
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return '';
  const today = startOfDay(now);
  const target = startOfDay(date);
  const dayDiff = Math.round((target - today) / 86400000);
  const time = formatHourLabel(date);
  if (dayDiff === 0) return `Hoje · ${time}`;
  if (dayDiff === 1) return `Amanhã · ${time}`;
  if (dayDiff === -1) return `Ontem · ${time}`;
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)} · ${time}`;
}

export function formatAppointmentRow(iso) {
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return '';
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)} · ${formatHourLabel(date)}`;
}

export function toLocalInputValue(iso) {
  const date = iso ? new Date(iso) : new Date();
  if (!Number.isFinite(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

export function pickNextAppointment(items, now = Date.now()) {
  const upcoming = (items || [])
    .map(item => {
      const iso = item?.item_details?.scheduled_at || item?.scheduled_at;
      const at = iso ? new Date(iso).getTime() : NaN;
      return { item, iso, at };
    })
    .filter(entry => Number.isFinite(entry.at))
    .sort((a, b) => a.at - b.at);
  if (!upcoming.length) return null;
  return (
    upcoming.find(entry => entry.at >= now) || upcoming[upcoming.length - 1]
  );
}
